import type { people as en } from "../en/people";
import type { Messages } from "../types";

export const people: Messages<typeof en> = {
  bar: {
    toolbar: "إجراءات للأشخاص المحددين",
    selected_zero: "المحدد: {{count}}",
    selected_one: "المحدد: {{count}}",
    selected_two: "المحدد: {{count}}",
    selected_few: "المحدد: {{count}}",
    selected_many: "المحدد: {{count}}",
    selected_other: "المحدد: {{count}}",
    selectAll: "تحديد الظاهرين",
    selectAllFiltered_zero: "تحديد كل المطابقين ({{count}})",
    selectAllFiltered_one: "تحديد كل المطابقين ({{count}})",
    selectAllFiltered_two: "تحديد كل المطابقين ({{count}})",
    selectAllFiltered_few: "تحديد كل المطابقين ({{count}})",
    selectAllFiltered_many: "تحديد كل المطابقين ({{count}})",
    selectAllFiltered_other: "تحديد كل المطابقين ({{count}})",
    allFiltered: "تم تحديد كل الأشخاص المطابقين",
    clear: "إلغاء التحديد",
    select: "تحديد @{{name}}",
    shiftHint: "اضغط Shift مع النقر لتحديد مجموعة",
    more: "إجراءات أخرى",
    running: "جارٍ التنفيذ…",
  },
  filters: {
    label: "التصفية",
    blocked: "الحظر",
    blockedOpts: { all: "الجميع", only: "المحظورون", exclude: "غير المحظورين" },
    flagged: "الوسوم",
    flaggedOpts: { all: "الجميع", only: "عليهم وسوم", exclude: "بلا وسوم" },
    has: "تعليقاتهم",
    hasOpts: { all: "أي تعليقات", hidden: "لديهم تعليقات مخفية", deleted: "لديهم تعليقات محذوفة", hidden_or_deleted: "مخفية أو محذوفة" },
  },
  actions: {
    flag: "وسم",
    flagAdd: "إضافة وسم",
    flagRemove: "إزالة وسم",
    mark: "تصنيف كـ",
    markClear: "إزالة التصنيف",
    block: "حظر في منصة ملفك",
    unblock: "إلغاء الحظر",
    hide: "إخفاء كل تعليقاتهم",
    unhide: "إظهار تعليقاتهم",
    archive: "أرشفة كل تعليقاتهم",
    unarchive: "إلغاء أرشفة تعليقاتهم",
    delete: "حذف كل تعليقاتهم",
    export: "تصدير (CSV)",
    exported: "تم تصدير الأشخاص",
    failed: "لم ينجح ذلك",
    lockedRole: "متاح للمحررين فما فوق",
    adminOnly: "حذف كل التعليقات متاح للمشرفين والمالكين فقط",
    hideConfirm: "إخفاء كل تعليقات {{who}}؟",
    hideHint: "تُخفى تعليقاتهم على إنستغرام عن الآخرين. يمكنك إظهارها لاحقاً.",
    unhideConfirm: "إظهار التعليقات المخفية من {{who}}؟",
    unhideHint: "كل تعليق مخفي منهم يعود ظاهراً على إنستغرام.",
    archiveConfirm: "أرشفة كل تعليقات {{who}}؟",
    archiveHint: "التعليقات المؤرشفة تخرج من صندوق الوارد وقوائم المنشورات في منصة ملفك. لا شيء يتغير على إنستغرام.",
    unarchiveConfirm: "إرجاع التعليقات المؤرشفة من {{who}}؟",
    who_zero: "{{count}} شخص",
    who_one: "شخص واحد",
    who_two: "شخصان",
    who_few: "{{count}} أشخاص",
    who_many: "{{count}} شخصًا",
    who_other: "{{count}} شخص",
    done: "تم",
    started: "بدأ التنفيذ — تابعه في المهام",
  },
  block: {
    title: "حظر {{who}} في منصة ملفك",
    explain: "إنستغرام لا يسمح للتطبيقات بحظر الأشخاص، لذلك هذا حظر خاص بمنصة ملفك:",
    effects: {
      hide: "يمكن إخفاء تعليقاتهم الحالية الآن، وكل تعليق جديد منهم يُخفى فور وصوله.",
      dms: "رسائلهم تصل وتُحفظ، لكنها مكتومة: خارج صندوق الوارد، بلا إشعارات، وبلا ردود ذكاء اصطناعي أو ردود تلقائية.",
      rules: "القواعد تتجاهلهم (إلا القواعد التي تستخدم «صاحب التعليق محظور في منصة ملفك»).",
    },
    reason: "السبب (اختياري)",
    reasonPlaceholder: "مثلاً: روابط سبام متكررة",
    scope: "النطاق",
    scopeAll: "كل الحسابات",
    scopeAccount: "فقط @{{account}}",
    hideExisting: "إخفاء تعليقاتهم الحالية الآن",
    visibleCount_zero: "التعليقات الظاهرة الآن: {{count}}",
    visibleCount_one: "التعليقات الظاهرة الآن: {{count}}",
    visibleCount_two: "التعليقات الظاهرة الآن: {{count}}",
    visibleCount_few: "التعليقات الظاهرة الآن: {{count}}",
    visibleCount_many: "التعليقات الظاهرة الآن: {{count}}",
    visibleCount_other: "التعليقات الظاهرة الآن: {{count}}",
    confirm: "حظر في منصة ملفك",
    done: "تم الحظر في منصة ملفك",
  },
  unblock: {
    title: "إلغاء حظر {{who}}؟",
    hint: "التعليقات والرسائل الجديدة منهم تُعامل بشكل طبيعي مرة أخرى.",
    unhide: "إظهار التعليقات التي أخفاها الحظر أيضاً",
    unhideCount_zero: "مخفية بسبب الحظر: {{count}}",
    unhideCount_one: "مخفية بسبب الحظر: {{count}}",
    unhideCount_two: "مخفية بسبب الحظر: {{count}}",
    unhideCount_few: "مخفية بسبب الحظر: {{count}}",
    unhideCount_many: "مخفية بسبب الحظر: {{count}}",
    unhideCount_other: "مخفية بسبب الحظر: {{count}}",
    confirm: "إلغاء الحظر",
    done: "تم إلغاء الحظر",
  },
  delete: {
    title: "حذف كل تعليقات {{who}}؟",
    hint: "يُحذف كل تعليق على إنستغرام، على منشوراتك فقط. يحتفظ ملفك بنسخة معلَّمة «حذفه ملفك» حتى لا يضيع شيء. لا يمكن التراجع عن الحذف على إنستغرام.",
    counting: "جارٍ عدّ تعليقاتهم…",
    impact: "تعليقات ستُحذف: {{comments}} · أشخاص: {{people}}",
    none: "لم يبق لهم تعليقات لحذفها.",
    typeToConfirm: "اكتب {{word}} للتأكيد",
    confirm: "حذف التعليقات",
  },
  badge: {
    blocked: "محظور",
    blockedTip: "محظور في منصة ملفك · {{scope}} · بواسطة {{by}} · {{when}}",
    blockedReason: "السبب: {{reason}}",
    scopeAll: "كل الحسابات",
    scopeAccount: "حساب واحد",
    someone: "أحد أعضاء الفريق",
    muted: "مكتوم",
    mutedTip: "هذا الشخص محظور في منصة ملفك: رسائله محفوظة لكنها مكتومة.",
    hiddenByBlock: "مخفي: محظور",
    hiddenByBlockTip: "أُخفي تلقائيًا لأن صاحبه محظور في منصة ملفك.",
  },
  instagram: {
    block: "الحظر على إنستغرام",
    tip: "إنستغرام لا يسمح للتطبيقات بحظر الأشخاص. يفتح هذا ملفهم الشخصي لتحظرهم من تطبيق إنستغرام.",
  },
  quick: {
    blockPerson: "حظر هذا الشخص",
    unblockPerson: "إلغاء حظر هذا الشخص",
    title: "الإشراف",
  },
  inbox: {
    muted: "المكتومون (المحظورون)",
  },
  /** ALP-84 S5: صفحة أشخاص واحدة بعرضين، وروابط ملف العميل. */
  hub: {
    title: "الأشخاص",
    hint: {
      everyone: "كل من علّق أو راسلك، بملف واحد لكل شخص.",
      commenters: "كل من علّق على حساب واحد، مع أدوات للتصنيف والإخفاء والحظر.",
    },
    views: { label: "العرض", everyone: "الجميع", commenters: "المعلّقون" },
    layout: { label: "التخطيط", table: "جدول", cards: "بطاقات" },
    columns: { select: "تحديد", person: "الشخص", lastActive: "آخر نشاط", comments: "التعليقات", status: "الحالة", actions: "الإجراءات" },
    noStatus: "بلا حالة",
    filters: "التصفية",
    filtersLabel: "تصفية الأشخاص",
    filtersOn: "التصفية (مفعّل: {{n}})",
    clearFilters: "مسح التصفية",
    allTags: "كل الوسوم",
    openInbox: "افتح صندوق الوارد",
    noAccount: "اربط حسابًا لترى من يعلّق",
    noAccountHint: "يظهر المعلّقون لكل حساب إنستغرام على حدة.",
    connect: "اربط إنستغرام",
    openProfile: "فتح الملف الشخصي",
    openConversation: "فتح المحادثة",
    noConversation: "لم يرسل لك رسالة بعد",
    allComments: "كل تعليقاته",
    instagram: "إنستغرام",
    profileAndData: "الملف العام والبيانات الشخصية",
    profileAndDataHint: "حدّث ملفه من إنستغرام، أو صدّر بياناته أو احذفها.",
  },
};
